import { dataBox } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBox = /*#__PURE__*/createIcon(dataBox)
export default IconBox
